import React, { forwardRef } from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  helperText?: string;
  error?: string;
  icon?: React.ReactNode;
  iconPosition?: 'left' | 'right';
  fullWidth?: boolean;
}
const Input = forwardRef<HTMLInputElement, InputProps>(({
  label,
  helperText,
  error,
  icon,
  iconPosition = 'left',
  fullWidth = true,
  className = '',
  id,
  ...props
}, ref) => {
  const inputId = id || `input-${Math.random().toString(36).substr(2, 9)}`;
  const baseInputStyles = 'block bg-white rounded-md shadow-sm focus:ring-2 focus:ring-offset-0 focus:outline-none transition-colors duration-200';
  const stateStyles = error ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500 focus:border-red-500' : 'border-gray-300 focus:ring-blue-500 focus:border-blue-500';
  const sizeStyles = 'py-2 px-3 text-sm';
  const iconStyles = icon ? iconPosition === 'left' ? 'pl-10' : 'pr-10' : '';
  const widthStyles = fullWidth ? 'w-full' : '';
  const combinedClassName = `
    ${baseInputStyles}
    ${stateStyles}
    ${sizeStyles}
    ${iconStyles}
    ${widthStyles}
    ${className}
  `.trim();
  return <div className={fullWidth ? 'w-full' : ''} data-id="element-183">
        {label && <label htmlFor={inputId} className="block text-sm font-medium text-gray-700 mb-1" data-id="element-184">
            {label}
          </label>}
        <div className="relative" data-id="element-185">
          {icon && iconPosition === 'left' && <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-500" data-id="element-186">
              {icon}
            </div>}
          <input ref={ref} id={inputId} className={combinedClassName} {...props} data-id="element-187" />
          {icon && iconPosition === 'right' && <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none text-gray-500" data-id="element-188">
              {icon}
            </div>}
        </div>
        {(helperText || error) && <p className={`mt-1 text-xs ${error ? 'text-red-600' : 'text-gray-500'}`} data-id="element-189">
            {error || helperText}
          </p>}
      </div>;
});
Input.displayName = 'Input';
export default Input;